import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import Clients, { getClients } from "../helpers/Clients";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import Invoices, { getInvoice } from "../helpers/Invoices";
import { format } from "../helpers/Currency";


export default function Invoice() {
    const { appState } = useAppState();
    const [invoice, setInvoice] = useState<any>()
    const navigate = useNavigate()
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            getInvoice(parseInt(id)).then((result) => {
                setInvoice(result)
            })
        }
    }, [id])

    if (!invoice) {
        return null
    }


    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Invoices \ Invoice</h1>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <div className="flex flex-wrap gap-10">
                    <div className="">
                        <h3 className="text-xl">Information</h3>
                    </div>
                    <div className="space-y-2">
                        <div><b>Id:</b> {invoice.id}</div>
                        <div><b>Client:</b> <Link className="hover:text-blue-600 focus:text-blue-600 text-blue-500" to={`/clients/${invoice.client.id}`}>{invoice.client.name}</Link></div>
                        <div><b>Status:</b> {invoice.status}</div>
                        <div><b>Total:</b> {format(invoice.total / 100, invoice.currency)}</div>
                        <div><b>Date created:</b> {dayjs(invoice.created_at).format('L LT')}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
